var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mia-settings-basics-invoice-form'),_c('mia-settings-basics-invoice-sepa-form',{staticClass:"mt-16"}),(_vm.isRoot)?_c('mia-settings-basics-invoice-pricing-form',{staticClass:"mt-16"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }